<template>
  <div :id="parentid"></div>
</template>

<script>
export default {
    props: ['id', 'columns', 'data', 'gridattr', 'bind'],
    data: function(){
        return {
            gridObject: null,
            parentid: this.id
        }
    },
    mounted: function(){
        this.gridObject = window._SBGrid.create({
            ...this.gridattr || {}, // { rowheader: ['seq'], explorerbar: 'sortmove'},
            id: this.id,
            parentid: this.parentid,
            columns: this.columns || [
                {
                    caption : ['col1'],	
                    ref : 'selectHeader_col1',
                    width : '200px',
                    style : 'text-align:center',
                    type : 'input',
                },
                {
                    caption : ['col2'],
                    ref : 'selectHeader_col2',
                    width : '200px',
                    style : 'text-align:center',
                    type : 'input',
                }
            ],
            jsonref: this.data || [{}],
        })
        if(this.bind != null) {
            for(let i = 0 ; i < Object.keys(this.bind).length; i++){                
                this.gridObject.bind(Object.keys(this.bind)[i], Object.values(this.bind)[i])
            }
        }
    }
}
</script>

<style>
</style>